"use strict";
exports.__esModule = true;
exports.selectionElements = exports.profileColors = exports.borderColors = exports.gradientColors = exports.fontColors = exports.statusColors = exports.logoColors = exports.credentialCardColors = exports.backgroundColors = void 0;
exports.backgroundColors = {
    primaryDark: '#202537',
    secondaryDark: '#2C334B',
    primaryLight: '#FBFBFB',
    secondaryLight: '#E3E3FF',
    lightGrey: '#E3E3E3'
};
exports.credentialCardColors = {
    "default": '#5BDED2'
};
exports.logoColors = {
    "default": '#FBFBFB'
};
exports.statusColors = {
    valid: '#00C249',
    expired: '#FF9900',
    revoked: '#EE5309',
    verified: '#00C249',
    unverified: '#FF9900',
    error: '#D74500'
};
exports.fontColors = {
    dark: '#303030',
    light: '#FBFBFB',
    secondaryButton: '#7664F2',
    greyedOut: '#8F8F8F',
    lightGrey: '#8D9099'
};
exports.gradientColors = {
    100: 'linear-gradient(135deg, #7276f7 0%, #7c40e8 100%)',
    200: 'linear-gradient(135deg, #F90 0%, #EE5309 100%)'
};
exports.borderColors = {
    dark: '#404D7A',
    light: '#E3E3E3',
    lightGrey: '#ACACAC'
};
exports.profileColors = {
    100: '#EE5209',
    200: '#FF9900',
    300: '#5BDED3',
    400: '#0B81FF',
    500: '#BD2DFF'
};
exports.selectionElements = {
    primaryDark: '#0B81FF',
    primaryBorderDark: '#FBFBFB'
};
